import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { renderAsync } from 'docx-preview';

@Component({
  selector: 'nc-word-viewer',
  templateUrl: './word-viewer.component.html',
  styleUrls: ['./word-viewer.component.less']
})
export class WordViewerComponent implements OnChanges {
  /** word文件地址 */
  @Input() ncUrl: string = '';

  constructor(private eleRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.renderWordDocument();
    }
  }

  async renderWordDocument() {
    try {
      const response = await fetch(this.ncUrl);
      const blob = await response.blob();
      const container = this.eleRef.nativeElement.querySelector('#word-container');
      await renderAsync(blob, container);
    } catch (error) {
      console.error('渲染Word文档时出错:', error);
    }
  }
}
